/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Status_Running7Inputs */

const en__field__enum_status_running7 = /** @type {(inputs: _Field__Enum_Status_Running7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running`)
};

/** @type {(inputs: _Field__Enum_Status_Running7Inputs) => LocalizedString} */
const de__field__enum_status_running7 = en__field__enum_status_running7;

/**
* | output |
* | --- |
* | "Running" |
*
* @param {_Field__Enum_Status_Running7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_status_running7 = /** @type {((inputs?: _Field__Enum_Status_Running7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Status_Running7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_status_running7(inputs)
	return de__field__enum_status_running7(inputs)
});
export { _field__enum_status_running7 as "_field__enum_status_RUNNING" }